import { render, staticRenderFns } from "./IMOCrewList.vue?vue&type=template&id=23a1ade1&scoped=true&"
import script from "./IMOCrewList.vue?vue&type=script&lang=js&"
export * from "./IMOCrewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1ade1",
  null
  
)

export default component.exports